import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import type { Opdracht } from '../types/Opdracht'

interface Props {
  opdracht: Opdracht
}

export const AanvraagDetail = ({ opdracht }: Props) => {
  const {
    dienstCodeLabel = 'Dienst onbekend',
    subdienstCodeLabel = 'Subdienst onbekend',
    productCode = 'Productcode onbekend',
    specificatie = 'Specificatie onbekend',
  } = opdracht

  const items = [
    { title: 'Dienst', text: dienstCodeLabel },
    { title: 'Subdienst', text: subdienstCodeLabel },
    { title: 'Productcode', text: productCode },
    { title: 'Specificatie', text: specificatie },
  ]

  return (
    <>
      <Grid container spacing={2} sx={{ m: 'auto', width: '95%', p: 1 }}>
        {generateTextItems(items)}
      </Grid>
    </>
  )
}

/** Generard a `Grid` > `Typography` or `Grid` > `DisciplineIcon` based on an array. Used for less code duplication */
function generateTextItems(items) {
  return (
    <>
      {items.map((item) => {
        return (
          <Grid key={`${item.title}-${item.text}`} size={{ xs: 3 }}>
            <Typography gutterBottom variant="subtitle1">
              <b>{item.title}</b>
            </Typography>
            <Typography variant="body2">{item.text}</Typography>
          </Grid>
        )
      })}
    </>
  )
}
